/* eslint-disable sort-keys */
export const SLIDE_BACKGROUNDS = {
  blueLavaLamp: {
    className: 'blueLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/blue-mesh.webp',
    value: 'blueLavaLamp',
  },
  stars: {
    className: 'starsBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/stars.webp',
    value: 'stars',
  },
  white: {
    className: '',
    previewUrl: '',
    translationKey: 'content-editor.colors.white',
    value: 'white',
  },
  whiteLavaLamp: {
    className: 'whiteLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/white-mesh.webp',
    value: 'whiteLavaLamp',
  },

  // don't forget to add thumbnails later
  /* FTRPRF variants */
  FTRPRFBlueLavaLamp: {
    className: 'FTRPRFBlueLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/FTRPRF/blue-mesh.webp',
    value: 'FTRPRFBlueLavaLamp',
  },
  FTRPRFSideBlueLavaLamp: {
    className: 'FTRPRFSideBlueLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/FTRPRF/side-blue-mesh.webp',
    value: 'FTRPRFSideBlueLavaLamp',
  },
  FTRPRFWhiteLavaLamp: {
    className: 'FTRPRFWhiteLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/FTRPRF/white-mesh.webp',
    value: 'FTRPRFWhiteLavaLamp',
  },
  /* CodeCosmos variants */
  CodeCosmosBlueLavaLamp: {
    className: 'CodeCosmosBlueLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeCosmos/blue-mesh.webp',
    value: 'CodeCosmosBlueLavaLamp',
  },
  CodeCosmosSideBlueLavaLamp: {
    className: 'CodeCosmosSideBlueLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeCosmos/side-blue-mesh.webp',
    value: 'CodeCosmosSideBlueLavaLamp',
  },
  CodeCosmosWhiteLavaLamp: {
    className: 'CodeCosmosWhiteLavaLampBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeCosmos/white-mesh.webp',
    value: 'CodeCosmosWhiteLavaLamp',
  },
  /* CodeFever variants */
  CodeFeverAnonymous: {
    value: 'CodeFeverAnonymous',
    className: 'CodeFeverAnonymousBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeFever/tn_achtergrond-CF-anonymous.jpg',
  },
  CodeFeverEriders: {
    value: 'CodeFeverEriders',
    className: 'CodeFeverEridersBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeFever/tn_achtergrond-CF-eriders.jpg',
  },
  CodeFeverMinecraft: {
    value: 'CodeFeverMinecraft',
    className: 'CodeFeverMinecraftBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeFever/tn_achtergrond-CF-minecraft.jpg',
  },
  CodeFeverPython: {
    value: 'CodeFeverPython',
    className: 'CodeFeverPythonBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeFever/tn_achtergrond-CF-python.jpg',
  },
  CodeFeverStreepke: {
    value: 'CodeFeverStreepke',
    className: 'CodeFeverStreepkeBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeFever/tn_achtergrond-CF-streep.jpg',
  },
  CodeFeverGame: {
    value: 'CodeFeverGame',
    className: 'CodeFeverGameBackground',
    previewUrl:
      'https://codefeverpublic.blob.core.windows.net/backgrounds/thumbnails/CodeFever/tn_achtergrond-CF-game.webp',
  },
};
